import { useDispatch, useSelector } from 'react-redux'
import { Element } from '../../../../common/html/element'
import { Pagination } from '../../../../common/pagination'
import { Table } from '../../../../common/table'
import {
  PAGE_SIZE_OPTIONS,
  SAVED_CRITERIA_COLUMN_ID,
} from '../../common/constant'
import {
  changeFilter,
  selectCriteriaById,
  selectCriteriaIds,
  selectFilter,
  selectLoading,
  selectSelectedCriteria,
  selectTotalRecords,
} from '../store/slice'
import { getSavedCriteria } from '../store/thunk'
import { DateTimeCell } from './DateTimeCell'
import { DeleteCell } from './DeleteCell'
import classes from './index.module.scss'
import { NameCell } from './NameCell'

export const CriteriaTable = () => {
  const dispatch = useDispatch()

  const filter = useSelector(selectFilter())
  const rowIds = useSelector(selectCriteriaIds())
  const totalRecords = useSelector(selectTotalRecords)
  const selectedCriteriaId = useSelector(selectSelectedCriteria((i) => i?.id))
  const isLoading = useSelector(selectLoading('criterias'))

  const getSchema = () => {
    const schema = Object.keys(SAVED_CRITERIA_COLUMN_ID).map((key) => {
      const isNameCol =
        SAVED_CRITERIA_COLUMN_ID[key] === SAVED_CRITERIA_COLUMN_ID.CRITERIA_NAME
      return {
        colId: SAVED_CRITERIA_COLUMN_ID[key],
        title: 'screening.' + key,
        isI18n: true,
        thStyle: { textAlign: 'left' },
        tdStyle: {
          width: isNameCol ? '70%' : '15%',
          minWidth: isNameCol ? '' : 150,
        },
        sortable: isNameCol ? false : true,
        render: (data, { rowId, isHovered }) => {
          return isNameCol ? (
            <NameCell name={data} rowId={rowId} isHovered={isHovered} />
          ) : (
            <DateTimeCell data={data} />
          )
        },
      }
    })

    schema.push({
      colId: 'deleteCol',
      title: '',
      tdStyle: { width: 30 },
      render: (data, { rowId }) => <DeleteCell rowId={rowId} />,
    })

    return schema
  }

  const onRowClick = (rowId) => {
    if (!selectedCriteriaId || selectedCriteriaId !== rowId) {
      dispatch(getSavedCriteria({ Id: rowId }))
    }
  }

  const setPage = (page) => dispatch(changeFilter({ page }))
  const setPageSize = (pageSize) =>
    dispatch(changeFilter({ pageSize, page: 1 }))

  const renderPagination = () => {
    return (
      <Pagination
        page={filter.page}
        pageSize={filter.pageSize}
        pageSizeOptions={PAGE_SIZE_OPTIONS}
        total={totalRecords}
        setPage={setPage}
        setPageSize={setPageSize}
      />
    )
  }

  const handleChangeSort = (sort) => {
    dispatch(changeFilter({ ...sort, page: 1 }))
  }

  return (
    <Element className={classes.criteriaTable}>
      <Table
        ids={rowIds}
        getDataFromRedux={selectCriteriaById}
        isLoading={isLoading}
        schema={getSchema()}
        renderPagination={renderPagination}
        selectedRowId={selectedCriteriaId}
        onRowClick={onRowClick}
        sort={{
          sortBy: filter.sortBy,
          sortDirection: filter.sortDirection,
        }}
        changeSort={handleChangeSort}
        isNoDataWithHead
        noDataText="screening.NO_SEARCH_CRITERIA"
      />
    </Element>
  )
}
